/**
 * 说明
 * 1. 白名单内的接口不需要401调logout
 */

const Apiwhitelist = ["/fleet/logout"];

export default Apiwhitelist;
